export enum CancellationReason {
  MISSING_FEATURES = 'missing-features',
  TECHNICAL_ISSUES = 'technical-issues',
  BETTER_ALTERNATIVE = 'better-alternative',
  OTHER = 'other',
}

export const CANCELLATION_REASONS = [
  { value: CancellationReason.MISSING_FEATURES, label: 'Missing features I need' },
  { value: CancellationReason.TECHNICAL_ISSUES, label: 'Technical issues' },
  { value: CancellationReason.BETTER_ALTERNATIVE, label: 'Found a better alternative' },
  { value: CancellationReason.OTHER, label: 'Other' },
]

export enum DeactivateModalStep {
  CONFIRMATION = 'confirmation',
  FEEDBACK = 'feedback',
}

export const NO_OF_FREE_TRIAL_DAYS = 14
